import { InsightsApi } from '@insights/insights-data-provider';

let service: InsightsApi;

export const insightsApiService = () => {
  if (!service) {
    service = new InsightsApi();
  }

  return service;
};
